module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_31-87405f8c55f699a385473b2ddbe3e40a.png";